import { addWeeks } from "date-fns";
import { Calendar } from "~/components/ui/calendar";
import { useContext, useEffect } from "react";
import { useTypedFetcher } from "remix-typedjson";
import { BookingFormContext } from "~/components/booking/ContextProvider";
import { type loader as dateAvailabilityLoader } from "~/routes/resources+/book+/date-availability";
import { route } from "~/utils/route";
import { Label } from "~/components/ui/label";
import { getUkDate } from "~/utils/date";

export function CalendarInput() {
  const context = useContext(BookingFormContext);
  if (!context) {
    throw new Error("BookingFormContext is not provided");
  }

  const {
    selectedDate,
    setSelectedDate,
    selectedBarberId,
    selectedServiceIds,
  } = context;

  const dateAvailabilityFetcher =
    useTypedFetcher<typeof dateAvailabilityLoader>();

  useEffect(() => {
    const url = route("/resources/book/date-availability");
    const searchParams = new URLSearchParams();
    searchParams.set("barberId", selectedBarberId);
    selectedServiceIds.forEach((serviceId) => {
      searchParams.append("serviceIds", serviceId);
    });

    dateAvailabilityFetcher.load(url + "?" + searchParams.toString());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedBarberId, selectedServiceIds, selectedDate]);

  return (
    <div>
      <Label htmlFor="date-select" className="px-6">
        Date
      </Label>
      <div className="mt-2" />
      <Calendar
        id="date-select"
        fromDate={getUkDate()}
        toDate={addWeeks(getUkDate(), 2)}
        value={selectedDate}
        onChange={(date) => {
          setSelectedDate(date);
        }}
        availabilities={dateAvailabilityFetcher.data?.availabilities}
      />
    </div>
  );
}
